// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2khZm","right":"Footer_right__2jMBz","buttons":"Footer_buttons__fufPq"};